/* global localStorage*/
import Vue from 'vue'
import axios from 'axios';
import store from './store/store.js'

export default {
    login(username, pass, cb) {
        cb = arguments[arguments.length - 1]
        authenticate(username, pass, (response) => {
            if (response.authenticated) {
                if (cb) cb(response)
            } else {
                if (cb) cb(response)
            }
        })
    },

    getToken() {
        return localStorage.sessionId;
    },

    logout(cb) {
        //delete localStorage.sessionId;
        store.commit('setUserData', {});
        if (cb) cb()
    },

    loggedIn() {
        return store.state.userInfo.loggedIn;
    }

}


function authenticate(username, pass, cb) {
    const loginUrl = window.location.pathname === '/po-dev/' ? '/po-dev/api/v1/login.php' : '/api/login.php'
    axios.post(loginUrl, {
            username: username,
            password: pass
        })
        .then(response => {
            // success callback
            var expirationDate = new Date();
            expirationDate.setMinutes(expirationDate.getMinutes() + 10);
            response.data.expirationDate = expirationDate;
            if (response.data.loggedIn === true) {
                cb({
                    authenticated: true,
                    user: response.data
                })
            } else {
                cb({
                    authenticated: false,
                    errorMsg: response.data.message
                })
            }
        }, error => {
            // error callback
            console.log(error);
            cb({
                authenticated: false,
                errorMsg: 'Service not available, try again later please.',
                error: error
            })
        });
}


// WEBPACK FOOTER //
// ./src/auth.js